/**
 * Currency formatting utilities
 * Ensures consistent USD display across the platform with exactly 2 decimal places
 */

/**
 * Format a number as USD with exactly 2 decimal places
 * @param {number|string|null|undefined} amount - The amount to format
 * @returns {string} Formatted string like "$100.00"
 */
export function formatUSD(amount) {
  // Handle null, undefined, or invalid values
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '$0.00'
  }

  // Convert to number if string
  const num = typeof amount === 'string' ? parseFloat(amount) : amount

  // Format with exactly 2 decimal places
  return `$${num.toFixed(2)}`
}

/**
 * Format a number as USD without the dollar sign, with exactly 2 decimal places
 * @param {number|string|null|undefined} amount - The amount to format
 * @returns {string} Formatted string like "100.00"
 */
export function formatUSDRaw(amount) {
  // Handle null, undefined, or invalid values
  if (amount === null || amount === undefined || isNaN(amount)) {
    return '0.00'
  }

  // Convert to number if string
  const num = typeof amount === 'string' ? parseFloat(amount) : amount

  // Format with exactly 2 decimal places
  return num.toFixed(2)
}

/**
 * Parse a USD string to a number
 * @param {string} usdString - String like "$100.00" or "100.00"
 * @returns {number} Parsed number
 */
export function parseUSD(usdString) {
  if (!usdString) return 0

  // Remove $ and any commas, then parse
  const cleaned = usdString.replace(/[$,]/g, '')
  return parseFloat(cleaned) || 0
}
